<template>
  <div v-if="show" class="pm-overlay" @click.self="close">
    <div class="pm-modal" role="dialog" aria-modal="true" aria-labelledby="pm-title">
      <div class="pm-header">
        <span class="pm-title" id="pm-title">Data Export</span>
        <button class="pm-close" type="button" @click="close" aria-label="Close">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
      </div>

      <div class="pm-body">
        <h3 class="pm-section-title">Export My Data</h3>
        <p class="pm-section-desc">
          Download a ZIP archive of everything Kiey stores about your account — profile, messages, files, contacts, calls, voicemails, and invoices. We'll email you a download link when it's ready (usually within a few minutes). The link expires after 7 days.
        </p>

        <div class="pm-action-row">
          <button type="button" class="pm-btn-primary" :disabled="exporting || requested" @click="onExport">
            {{ exporting ? 'Preparing export…' : (requested ? 'Export requested' : 'Export My Data') }}
          </button>
        </div>

        <p v-if="errorMsg" class="pm-error">{{ errorMsg }}</p>
        <p v-if="requested && !errorMsg" class="pm-success">
          We're preparing your export. Check <strong>{{ userEmail }}</strong> in a few minutes.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { requestDataExport } from '@/util/data_export';

export default {
  props: {
    show: { type: Boolean, default: false },
    hide: { type: Function, required: true },
  },
  data() {
    return {
      exporting: false,
      requested: false,
      errorMsg: '',
    };
  },
  computed: {
    ...mapState({
      user: state => state.Authenticate.user,
    }),
    userEmail() {
      return (this.user && this.user.email) || 'your email';
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.exporting = false;
        this.requested = false;
        this.errorMsg = '';
      }
    },
  },
  methods: {
    close() {
      this.hide();
    },
    async onExport() {
      if (this.exporting || this.requested) return;
      this.exporting = true;
      this.errorMsg = '';
      try {
        await requestDataExport();
        this.requested = true;
      } catch (err) {
        console.error('Data export request failed:', err);
        this.errorMsg = "We couldn't start your export. Please try again or contact support@kiey.com.";
      } finally {
        this.exporting = false;
      }
    },
  },
};
</script>

<style scoped>
.pm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(6, 29, 71, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 16px;
}
.pm-modal {
  background: #ffffff;
  border-radius: 14px;
  width: 100%;
  max-width: 520px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.18);
  overflow: hidden;
  font-family: 'Roboto', Arial, sans-serif;
}
.pm-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px 12px;
  border-bottom: 1px solid #eef0f4;
}
.pm-title {
  font-size: 18px;
  font-weight: 600;
  color: #061d47;
}
.pm-close {
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #5e6b85;
  cursor: pointer;
}
.pm-close:hover { background: #f3f5f9; }

.pm-body { padding: 20px; }
.pm-section-title {
  margin: 0 0 6px;
  font-size: 15px;
  font-weight: 600;
  color: #061d47;
}
.pm-section-desc {
  margin: 0 0 16px;
  font-size: 13px;
  line-height: 19px;
  color: #5e6b85;
}
.pm-action-row { display: flex; }
.pm-btn-primary {
  background: #061d47;
  color: #ffffff;
  border: none;
  font-size: 14px;
  font-weight: 500;
  padding: 10px 22px;
  border-radius: 24px;
  cursor: pointer;
  transition: opacity 0.15s ease;
}
.pm-btn-primary:hover:not(:disabled) { opacity: 0.9; }
.pm-btn-primary:disabled { opacity: 0.5; cursor: not-allowed; }

.pm-error {
  color: #c0392b;
  font-size: 13px;
  margin: 14px 0 0;
}
.pm-success {
  color: #2e7d32;
  font-size: 13px;
  margin: 14px 0 0;
}
</style>
